import React, {Component, createRef} from 'react';
import Chart from 'chart.js/auto';

export default class adminDashboardCharts extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    console.log(this.props);
  }


  renderNewChatUsers() {
    let {new_chat_users} = this.props;
    return <BarsChart data={new_chat_users} title="New chat users"/>
  }

  renderResumeChatUsers() {
    let {resume_chat_users} = this.props;
    return <BarsChart data={resume_chat_users} title="Resume chat users"/>
  }

  render() {
    return (
      <div>
        {this.renderNewChatUsers()}
        {this.renderResumeChatUsers()}
      </div>
    );
  }
}


class BarsChart extends Component {
  constructor(props) {
    super(props);
    let chart_config = BarsChart.buildData(this.props);
    this.state = {chart_config};
    this.chartEl = createRef();
  }

  componentDidMount() {
    this.initChart();
  }

  initChart() {
    let {chart_config} = this.state;
    this.chart = new Chart(this.chartEl.current, chart_config);
  }

  static buildData(props) {
    let {data, title} = props;
    let {x, y} = groupByMonth(data, {field: 'created_at', untilToday: true});

    let config = {
      type: 'bar',
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      },
      data: {
        labels: x,
        datasets: [{
          label: title,
          data: y,
          fill: false,
          borderColor: 'rgb(75, 192, 192)',
          tension: 0.1
        }]
      }
    };
    return config;
  }

  render() {
    let {title} = this.props;
    return (
      <div>
        <h2>{title}</h2>
        <canvas ref={this.chartEl}></canvas>
      </div>
    );
  }
}



const MONTH_NAMES = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
]

function groupByMonth(input_data, opt={}) {
  for (let item of input_data) {
    if(opt.field) {
      item._date = new Date(item[opt.field]);
    } else {
      item._date = new Date(item);
    }
  }

  input_data.sort((a, b) => a._date - b._date);

  let first_date = input_data[0]._date;
  let last_date = input_data[input_data.length - 1]._date;

  let first_year = first_date.getFullYear();
  let first_month = first_date.getMonth();

  let last_year, last_month;
  if (opt.untilToday) {
    let today = new Date();
    last_year = today.getFullYear();
    last_month = today.getMonth();
  } else {
    last_year = last_date.getFullYear();
    last_month = last_date.getMonth();
  }

  let months;
  if (first_year === last_year) {
    months = last_month - first_month + 1;
  } else {
    months = 11 - first_month + 1;
    months += last_month + 1;
    let years = (last_year - first_year) - 1;
    months += years * 12;
  }

  // Create the buckets
  let data = [];
  for (let m=0; m < months; m++) {
    let month_index = m + first_month;
    let year_offset = Math.floor(month_index / 12);
    let month = month_index % 12;
    let year = first_year + year_offset;

    let label = `${MONTH_NAMES[month]} ${year}`;
    data.push({year, month, label, count: 0});
  }

  for (let item of input_data) {
    let item_year = item._date.getFullYear();
    let item_month = item._date.getMonth();
    let index = data.findIndex(d => d.month === item_month && d.year === item_year);
    if (index === -1) {
      console.log(data)
      console.log(item_month, item_year);
    }
    data[index].count++;
  }

  let x = data.map(d => d.label);
  let y = data.map(d => d.count);
  return {x, y};
}
